<template>
  <v-flex xs12 class="image-text-card">
    <v-layout class="wrapper" row wrap>
      <v-flex
        :class="[{'py-2 pl-0': $vuetify.breakpoint.smAndDown, 'pb-3 pl-0 pt-0': !$vuetify.breakpoint.smAndDown }, shrink ? 'card-content px-1' : 'pr-3' , colWidth]"
        v-for="object in objects"
        :key="object.id"
        :style="customStyle"
      >
        <v-card
          :height="cardHeight"
          :width="cardWidth"
          :class="{ 'un-selectable-card': !isCardSelectable, 'selected-card': selectCardId == object.id, 'disable-card': selectCardId != object.id && loading }"
          @click="setSelectedCard(object.id)"
        >
          <v-layout fill-height v-if="loading && selectCardId == object.id">
            <v-flex>
              <v-progress-circular
                :size="70"
                :width="4"
                color="primary"
                class="justify-center progress-circular"
                indeterminate
              />
            </v-flex>
          </v-layout>
          <template v-else>
            <v-card-title class="justify-center" :class="{'pa-0 pt-2 pb-1': shrink}">
              <img :src="object.imageUrl" :width="imgWidth" :height="imgHeight">
            </v-card-title>
            <v-card-text :class="{'pa-1 pb-1 ma-0': !shrink, 'pa-0 pb-2 px-1 ma-0': shrink}">
              <v-flex v-if="containsKey(object, 'title')">
                <slot name="title" :title="shortTitle && object.shortTitle? object.shortTitle : object.title" />
              </v-flex>
              <v-flex v-if="containsKey(object, 'content')" class="hint">
                <span class="px-3">
                  <slot name="content" :content="object.content" />
                </span>
              </v-flex>
            </v-card-text>
          </template>
        </v-card>
      </v-flex>
    </v-layout>
  </v-flex>
</template>
<script>
import {
  VCard,
  VCardTitle,
  VCardText,
  VFlex,
  VLayout,
  VProgressCircular
} from 'vuetify/lib';
export default {
  components: {
    VCard,
    VCardTitle,
    VCardText,
    VFlex,
    VLayout,
    VProgressCircular
  },
  props: {
    objects: {
      type: Object,
      default: null,
      required: true
    },
    cardHeight: {
      type: Number,
      default: 180
    },
    colWidth: {
      type: String,
      default: 'xs6 md3'
    },
    selectCardId: {
      type: Number,
      default: null
    },
    imgWidth: {
      type: String,
      default: '120'
    },
    imgHeight: {
      type: String,
      default: '120'
    },
    loading: {
      type: Boolean,
      default: false
    },
    shortTitle: {
      type: Boolean,
      default: false
    },
    cardWidth: {
      type: Number,
      default: null
    },
    customStyle: {
      type: Object,
      default: null
    },
    isCardSelectable: {
      type: Boolean,
      default: true
    },
    shrink: {
      type: Boolean,
      default: false
    }
  },
  created() {
    if (this.selectCardId) {
      this.selectedCardId = this.selectCardId;
    }
  },
  data() {
    return {
      selectedCardId: null
    }
  },
  methods: {
    setSelectedCard(id) {
      if (!this.loading && this.isCardSelectable) {
        this.selectedCardId = id;
        this.$emit('selected-card', id);
      }
    },
    containsKey(obj, key) {
      return Object.keys(obj).includes(key);
    }
  }
}
</script>
<style lang="scss" scoped>
.card-content {
  &:last-child {
    padding-right: 0px !important;
    padding-left: 8px !important;
  }
  &:first-child {
    padding-left: 0px !important;
    padding-right: 8px !important;
  }
  .v-card__text {
    @media screen and (max-width: 959px) {
      font-size: 12px !important;
    }
    @media screen and (min-width: 960px) {
      font-size: 14px !important;
    }
  }
}
.wrapper::-webkit-scrollbar {
  display: none;
}
.wrapper {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
::v-deep.image-text-card {
  .flex {
    .un-selectable-card{
      cursor: auto !important;
      &:hover {
        border: none !important;
      }
    }
    .selected-card {
      border: solid 1px var(--v-primary-base);
      background-color: var(--v-primary-variation-1-base);
    }
    .disable-card {
      background-color: var(--v-section-base);
      cursor: not-allowed !important;
      &:hover {
        border: none;
        background-color: var(--v-section-base);
      }
    }
    .v-card {
      cursor: pointer;
      &:hover{
        border: solid 1px var(--v-primary-base);
        transition: none;
      }
      .v-card__text {
        text-align: center;
        color: var(--v-black-base);
        line-height: 1.38;
        .hint {
          line-height: 1.42;
          opacity: 0.56;
          font-size: 12px;
          span {
            display: inline-block;
            width: 100%;
          }
        }
      }
      .progress-circular {
        margin: auto;
      }
    }
  }
}
</style>